import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ProfileComponent } from './components/profile/profile.component';
import { OlmapComponent } from './components/GIS/olmap/olmap.component';
import { ProfileGuard } from '@guards/route-deactivate-guard.service';
import { HomePageComponent } from '@components/home-page/home-page.component';
import { SubMenuAccessGuard } from '@guards/sub-menu-access-guard.guard';
import { InvalidEntriesGuard } from '@guards/invalid-entries.guard';
 
export const routes: Routes = [
  {
    path: '',
    data: {
      title: 'Profile',
    },
    component: ProfileComponent,
    pathMatch: 'full',
    // componentless route that runs guards and redirects as needed
    canActivate: [MsalGuard, InvalidEntriesGuard],
    canDeactivate: [ProfileGuard],
  },
  {
    path: 'myProfile',
    data: {
      title: 'Profile',
    },
    component: ProfileComponent,
    canActivate: [MsalGuard, InvalidEntriesGuard],
    canDeactivate: [ProfileGuard]
  },
  {
    path: 'home',
    data: { title: 'Home' },
    component: HomePageComponent,
    canActivate: [MsalGuard, InvalidEntriesGuard], // <- added InvalidEntriesGuard
  },
  {
    path: 'cat',
    loadChildren: () => import('./modules/cat/cat.module').then((m) => m.CatModule),
    canActivate: [MsalGuard, InvalidEntriesGuard, SubMenuAccessGuard],
  },
  {
    path: 'fsr',
    loadChildren: () => import('./modules/fsr/fsr.module').then((m) => m.FsrModule),
    canActivate: [MsalGuard, InvalidEntriesGuard, SubMenuAccessGuard],
  },
  {
    path: 'admin',
    data: {
      title: 'Configuration',
    },
    canActivate: [MsalGuard, InvalidEntriesGuard, SubMenuAccessGuard],
    loadChildren: () =>
      import('./modules/admin/admin-routing.module').then((m) => m.AdminRoutingModule),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
   // canActivate: [MsalGuard, InvalidEntriesGuard], 
  },
];
 
 